export const AUDIT_LEARNING_ERROR_CODES = {
  UNSAFE_LEARNING: 'unsafe-learning',
};

export function isUnsafeLearningErrorCode(code) {
  return code === AUDIT_LEARNING_ERROR_CODES.UNSAFE_LEARNING;
}

export const AUDIT_LEARNING_REJECTION_REASONS = {
  OVERRIDES_INSTRUCTIONS: 'overrides_instructions',
  FORCES_OUTCOME: 'forces_outcome',
  OUT_OF_SCOPE_BEHAVIOR: 'out_of_scope_behavior',
  INJECTION_SCAFFOLDING: 'injection_scaffolding',
  INSTRUCTIONS_TO_MODEL: 'instructions_to_model',
  CONTAINS_CLIENT_INFORMATION: 'contains_client_information',
  OTHER: 'other',
};

/**
 * @param {Object} [details] - The `details` payload of the callable error.
 * @returns {string}
 */
export function toLearningRejectionReason(details) {
  return Object.values(AUDIT_LEARNING_REJECTION_REASONS).includes(details?.reasonCode)
    ? details.reasonCode
    : AUDIT_LEARNING_REJECTION_REASONS.OTHER;
}

/**
 * Whether a save was refused because the stored learning is no longer in the state the page thought.
 *
 * Every precondition the backend enforces on a learning says the same thing to the reader: the list they
 * are looking at is stale. A revision already exists, or the learning has since been promoted, or it is
 * no longer active. The callable SDK reports the code both bare and namespaced depending on the call
 * path, so both are matched.
 *
 * @param {string} code
 * @returns {boolean}
 */
export function isStaleLearningErrorCode(code) {
  return ['failed-precondition', 'functions/failed-precondition'].includes(code);
}
